import { useIsAuthenticated } from '@azure/msal-react';
import React, { useEffect } from 'react';
import { RestfulProvider } from 'restful-react';
import { useDispatch } from 'react-redux';

import Root from './modules/core';
import { ducks as navigationDucks } from './modules/navigation';
import LoadingPanel from './ui/old/Feedback/LoadingPanel';
import useSwaggerApiInitialization from './useSwaggerApiInitialization';
import './i18n';
import { msalInstance } from './modules/auth';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const {
    navbar: { loadItems },
} = navigationDucks;

function App() {
    let token = undefined;
    const isAuthenticated = useIsAuthenticated();
    const dispatch = useDispatch();
    const handleLogin = async () => {
            await msalInstance.handleRedirectPromise().then((res) =>{
                if(res != null)
                {
                    token = res?.accessToken;
                    msalInstance.setActiveAccount(res.account)
                }
            })

            const account = msalInstance.getActiveAccount();
            if (!account) {
                msalInstance.loginRedirect();
            }
    };
    useSwaggerApiInitialization();

    useEffect(() => {
        handleLogin();
        if (isAuthenticated) {
            dispatch(loadItems());
        }
    }, [isAuthenticated]);
    return (
        <>
            {isAuthenticated ? (
                <RestfulProvider
                    base={process.env.REACT_APP_API_BASE_URL || ''}
                    requestOptions={{ headers: { Autorization: `Bearer ${token}` } }}
                >
                    <Root />
                    <ToastContainer
                        position="bottom-right"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        limit={5}
                    />
                </RestfulProvider>
            ) : (
                <LoadingPanel />
            )}
        </>
    );
}

export default App;
